import { render, staticRenderFns } from "./PartnerOrdersForMe.vue?vue&type=template&id=23eb640d&"
import script from "./PartnerOrdersForMe.vue?vue&type=script&lang=js&"
export * from "./PartnerOrdersForMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports